<template>
  <RegistryForm />
</template>

<script lang="ts" src="./RegistryView.ts"></script>

<style scoped lang="scss" src="./RegistryView.scss"></style>
